import configureStore from './appRedux/store'; //{ history } 

const store = configureStore(undefined); // Pass undefined instead of string comment

export default store;